import { Box } from '@careguide/theme'

const Card = ({ children, ...props }: TODO) => {
  return (
    <Box
      p='1rem'
      boxShadow='low-dark'
      css={`
        border-radius: 4px;
      `}
      {...props}
    >
      {children}
    </Box>
  )
}

export default Card
